import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { PublicOnSiteStore } from 'src/app/shared/services/public-on-site/public-on-site.state';

export const onSiteProtectedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const onSiteStore = inject(PublicOnSiteStore);
  const router = inject(Router);

  if (!onSiteStore.userDetails()) {
    const eventId = route.params['id'];
    router.navigate(['public', 'on-site', 'events', eventId, 'check-in'], {
      queryParams: route.queryParams
    });
    return false;
  }

  return true;
};
